export const locale = {
    lang: 'en',
    data: {
        HEADER: {
            'MEGA_MENU': 'Mega Menu',
            'QUICK_LINK': 'Quick Link',
        },
        SIDENAV: {
            DASHBOARDS: 'Dashboards',
            MAILBOX: 'Mailbox',
            CHAT: 'Chat',
            KNOWLADGE_BASE: 'Knowledge Base',
            CALENDAR: 'Calendar',
            CONTACTS: 'Contacts',
        },
    }
};
